import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Box, Divider, List, ListItem } from "@mui/joy";
import { useAuth } from "@providers/AuthProvider";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useEffect } from "react";
import { Link, Outlet, redirect, useLocation, useNavigate } from "react-router-dom";

export default function SettingsIndex() {
    const navigate = useNavigate();

    useEffect(() => {
      navigate('/tools/organization-settings');
    }, []);

    return null;
}
